export const S_TO_MIN_CONST = 60;
